<template>
  <footer
    class="mt-10 border-t border-zinc-800/80"
    aria-labelledby="footer-heading"
  >
    <h2 id="footer-heading" class="sr-only">Footer</h2>
    <div
      class="mx-auto flex max-w-7xl flex-col gap-6 px-5 py-10 sm:flex-row sm:items-center sm:justify-between sm:px-8"
    >
      <div class="flex items-center gap-3">
        <img class="h-7 w-auto" src="@/assets/logo.png" alt="Rayfish" />
        <p class="text-sm text-zinc-400">
          A private mesh network that works out of the box.
        </p>
      </div>

      <div class="flex flex-wrap items-center gap-x-6 gap-y-3">
        <a
          href="https://github.com/rayfish/rayfish"
          target="_blank"
          rel="noopener"
          class="inline-flex min-h-[44px] min-w-[44px] items-center text-zinc-400 transition-colors hover:text-zinc-100"
        >
          <span class="sr-only">GitHub</span>
          <svg
            class="h-5 w-5"
            fill="currentColor"
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z"
            />
          </svg>
        </a>
        <a
          href="https://iroh.computer"
          target="_blank"
          rel="noopener"
          class="text-sm text-zinc-400 transition-colors hover:text-zinc-100"
        >
          Built on iroh
        </a>
        <p class="font-mono text-xs text-zinc-600">© 2026 Rayfish</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterComp",
};
</script>
